module.exports = __webpack_public_path__ + "img/title.3687c824.png";